import { Component, OnInit } from '@angular/core';
import { OnPremiseProvider } from '../../providers/on-premise';

@Component({
    selector: 'on-premise-header',
    templateUrl: 'index.html'
})
export class OnPremiseHeaderComponent {
    constructor(private onPremiseProvider: OnPremiseProvider) {}

    public minimize(): void {
        this.onPremiseProvider.minimize();
    }
    public maximize(): void {
        this.onPremiseProvider.maximize();
    }
    public close(): void {
        this.onPremiseProvider.close();
    }
}



// WEBPACK FOOTER //
// ./src/components/on-premise-header/index.ts